export default __webpack_public_path__ + "static/media/Colorlib.639bb86e.jpg";